const LOCAL_DEV_HOSTS = new Set(["localhost", "127.0.0.1"]);

export function isLocalDevHost(hostname: string): boolean {
  return LOCAL_DEV_HOSTS.has(hostname.toLowerCase());
}

export function rewriteAppPublicUrl(apiUrl: string): string {
  if (typeof window === "undefined" || !apiUrl?.trim()) {
    return apiUrl;
  }

  try {
    const parsed = new URL(apiUrl, window.location.origin);
    const path = `${parsed.pathname}${parsed.search}${parsed.hash}`;

    if (isLocalDevHost(parsed.hostname)) {
      return `${window.location.origin}${path}`;
    }

    return apiUrl;
  } catch {
    if (apiUrl.startsWith("/")) {
      return `${window.location.origin}${apiUrl}`;
    }

    return apiUrl;
  }
}

export function currentAppPublicOrigin(): string | undefined {
  if (typeof window === "undefined" || !window.location?.origin) {
    return undefined;
  }

  return window.location.origin.replace(/\/$/, "");
}
